"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Logo = _interopRequireDefault(require("./Logo"));
// TODO: Refactor this or remove if not used by any other app
var _default = exports.default = _Logo.default;